import { useCallback, useEffect } from "react";
import useProcessedCallsStore from "./store";
import { getQueueStatistics } from "V2.0/services/outboundCommunication";

export default function useProcessedCallsState(workspaceId, assistantId) {
  const { state, updateCallQueueStats, updateIsLoading, updateQueuedAt } =
    useProcessedCallsStore();

  const fetchQueueStats = useCallback(
    async function (queuedAt) {
      updateIsLoading(true);

      try {
        const response = await getQueueStatistics({
          workspaceId,
          queuedAt,
          assistantId,
        });

        if (response.status === 200) {
          const { data } = response.data;
          updateCallQueueStats(data);
        }
      } catch (e) {
        updateIsLoading(false);
      }
    },
    [workspaceId, assistantId]
  );

  useEffect(
    function () {
      if (state.queuedAtTimestamp) {
        fetchQueueStats(state.queuedAtTimestamp);
      }
    },
    [state.queuedAtTimestamp]
  );

  return {
    state,
    fetchQueueStats,
    updateQueuedAt,
  };
}
